import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import api from "../api";
import { ProgressSpinner } from 'primereact/progressspinner';
import { scheduleTokenRefresh } from "../utils/tokenUtils";

const ProtectedRoute = ({ children }) => {
    const [checking, setChecking] = useState(true);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    useEffect(() => {
        const verifyAccessToken = async () => {
            const token = localStorage.getItem("authToken");

            const tryRefreshToken = async () => {
                try {
                    const response = await api.post("/api/auth/refreshAccessToken");
                    const newAccessToken = response.data.accessToken;
                    localStorage.setItem("authToken", newAccessToken);
                    scheduleTokenRefresh(newAccessToken);
                    setIsAuthenticated(true);
                } catch (err) {
                    console.error("❌ Refresh token failed:", err);
                    setIsAuthenticated(false);
                } finally {
                    setChecking(false);
                }
            };

            if (!token) {
                await tryRefreshToken();
                return;
            }

            try {
                const decoded = jwtDecode(token);
                const currentTime = Date.now() / 1000;
                const timeLeft = decoded.exp - currentTime;

                if (timeLeft < 0) {
                    await tryRefreshToken();
                } else if (timeLeft < 60) {
                    await tryRefreshToken();
                } else {
                    scheduleTokenRefresh(token);
                    setIsAuthenticated(true);
                    setChecking(false);
                }
            } catch (decodeError) {
                console.error("❌ Invalid token structure:", decodeError);
                await tryRefreshToken();
            }
        };

        verifyAccessToken();

        return () => {
        };
    }, []);

    if (checking) {
        return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
                <ProgressSpinner />
            </div>
        );
    }

    return isAuthenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;

